/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { makeStyles, Typography, Grid } from '@material-ui/core';

import { ReactComponent as IconShare } from '../../assets/images/ic-share.svg';

const useStyles = makeStyles((theme) => ({
  image: {
    cursor: 'pointer',
    height: '40px',
    width: 'auto',
    [theme.breakpoints.up('md')]: {
      height: '26px',
      width: 'auto',
    },
  },
  imageIconShare: {
    stroke: theme.palette.primary.main,
  },
  linkContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    gap: '4px',
    minWidth: 'fit-content',
  },
  text: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    display: 'none',
    fontSize: '14px',
    lineHeight: '24px',
    marginLeft: '3px',
    [theme.breakpoints.up('md')]: {
      display: 'inline-block',
    },
  },
}));

export default ({ onClick }) => {
  const classes = useStyles();

  const handleClick = () => {
    if (!onClick && typeof onClick !== 'function') return;
    onClick();
  };

  return (
    <Grid container className={classes.linkContainer} alignItems="center">
      <IconShare onClick={handleClick} className={`${classes.image} ${classes.imageIconShare}`} />
      <Typography onClick={handleClick} className={classes.text}>
        Share Video Report
      </Typography>
    </Grid>
  );
};
